// Lightweight analytics helpers used by public pages.
// Pageviews are tracked automatically by <PageTracker />; this helper
// covers explicit click / conversion events (e.g. "Prenota Ora").

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const trackClick = (label, extra = {}) => {
  if (!label) return;
  try {
    fetch(`${BACKEND_URL}/api/analytics/track-event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_type: 'click',
        label,
        page: typeof window !== 'undefined' ? window.location.pathname : '',
        ...extra,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch (_e) {
    /* fire and forget */
  }
};
